import { HttpClient, HttpError } from '../client';
import { ServiceConfig } from './types';
import { RequestMetadata } from '../../../types/api';

export abstract class BaseService {
  protected client: HttpClient;
  protected abstract readonly resourceName: string;

  constructor(config: ServiceConfig) {
    this.client = new HttpClient(config);
  }

  protected setAuthToken(token: string): void {
    this.client.setAuthToken(token);
  }

  protected clearAuthToken(): void {
    this.client.clearAuthToken();
  }

  protected setMetadata(metadata: Partial<RequestMetadata>): void {
    this.client.setMetadata(metadata);
  }

  protected handleError(error: unknown): never {
    if (error instanceof HttpError) {
      // Add service-specific error handling here
      switch (error.type) {
        case 'Unauthorized':
          this.clearAuthToken();
          break;
        case 'PermissionDenied':
          // Handle permission errors
          break;
        // Add other error type handling as needed
      }
    }
    throw error;
  }

  protected cancelRequest(method: string, url: string): void {
    this.client.cancelRequest(method, url);
  }

  protected cancelAllRequests(): void {
    this.client.cancelAllRequests();
  }

  protected getResourceUrl(path = ''): string {
    return `/${this.resourceName}${path}`;
  }
} 